import {
    BackgroundCheckColumns,
    BackgroundCheckData,
    backgroundCheckEntityName,
} from '@/backend/features/background-check/entities/background-check';
import { StorageContext } from '@juvare/platform-app/App';
import { StorageBackendApi } from '@juvare/platform-app/Storage';

export function getBackgroundCheckStorage(context: StorageContext): StorageBackendApi<BackgroundCheckData, BackgroundCheckColumns> {
    return context.storage<BackgroundCheckData, BackgroundCheckColumns>(backgroundCheckEntityName);
}
